import apiClient from './apiClient';

const AUDIT_BASE_URL = '/api/v1/audit';

/**
 * Fetch paginated audit logs with filters
 */
export const getAuditLogs = async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.admin_user_id) params.append('admin_user_id', filters.admin_user_id);
    if (filters.action_type) params.append('action_type', filters.action_type);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.pageSize) params.append('pageSize', filters.pageSize.toString());
    
    const response = await apiClient.get(`${AUDIT_BASE_URL}/admin-logs?${params}`);
    return response.data;
};

/**
 * Get audit log statistics
 */
export const getAuditStats = async (startDate, endDate) => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    
    const response = await apiClient.get(`${AUDIT_BASE_URL}/admin-logs/stats?${params}`);
    return response.data;
};

/**
 * Get list of action types
 */
export const getActionTypes = async () => {
    const response = await apiClient.get(`${AUDIT_BASE_URL}/admin-logs/actions`);
    return response.data;
};

/**
 * Get list of admins
 */
export const getAdmins = async () => {
    const response = await apiClient.get(`${AUDIT_BASE_URL}/admin-logs/admins`);
    return response.data;
};

/**
 * Get specific audit log by ID
 */
export const getAuditLogById = async (id) => {
    const response = await apiClient.get(`${AUDIT_BASE_URL}/admin-logs/${id}`);
    return response.data;
};

/**
 * Check audit service health
 */
export const getAuditHealth = async () => {
    const response = await apiClient.get(`${AUDIT_BASE_URL}/health`);
    return response.data;
};

